import {
    CREATE_COLOR_MASTER_FAILURE,
    CREATE_COLOR_MASTER_REQUEST,
    CREATE_COLOR_MASTER_SUCCESS,
    CREATE_USER_FORM_COLOR_MASTER,
    DELETE_COLOR_MASTER_FAILURE,
    DELETE_COLOR_MASTER_REQUEST,
    DELETE_COLOR_MASTER_SUCCESS,
    FETCH_COLOR_MASTER_FAILURE,
    FETCH_COLOR_MASTER_REQUEST,
    FETCH_COLOR_MASTER_SUCCESS,
    FETCH_SINGLE_COLOR_MASTER_FAILURE,
    FETCH_SINGLE_COLOR_MASTER_REQUEST,
    FETCH_SINGLE_COLOR_MASTER_SUCCESS,
    RESET_USER_FORM_COLOR_MASTER,
    UPDATE_COLOR_MASTER_FAILURE,
    UPDATE_COLOR_MASTER_REQUEST,
    UPDATE_COLOR_MASTER_SUCCESS
} from './colorMaster.actionsType';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';

// FETCH AREA MASTER
export let fetchColorMaster = () => {
    let config = {
        method: 'get',
        url: ConstantApi.colorMasterGET,
        responseTypeRequest: FETCH_COLOR_MASTER_REQUEST,
        responseTypeSuccess: FETCH_COLOR_MASTER_SUCCESS,
        responseTypeFailure: FETCH_COLOR_MASTER_FAILURE
    };
    return axiosCall(config);
};
// create user Form
export let createColorUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_COLOR_MASTER, payload: { key, value } });
    };
};

// CREATE AREA MASTER
export let createColorMaster = (userform, modalClose) => {
    let { code, color, ipv4 } = userform;
    let today = new Date();
    let data = JSON.stringify({
        fldCode: code,
        fldDescription: color,
        fldIsActive: true,
        fldEnteredSysId: ipv4,
        fldCreatedBy: 0,
        fldCreatedDt: today.toISOString()
    });
    console.log('data :>> ', data);
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.colorMasterPOST}`,
        responseTypeRequest: CREATE_COLOR_MASTER_REQUEST,
        responseTypeSuccess: CREATE_COLOR_MASTER_SUCCESS,
        responseTypeFailure: CREATE_COLOR_MASTER_FAILURE,
        resetFormData: RESET_USER_FORM_COLOR_MASTER,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchColorMaster()
    };
    return axiosCall(config);
};

// GET SINGLE Color MASTER
export let getSingleColorMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.colorMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_COLOR_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_COLOR_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_COLOR_MASTER_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateColorMaster = (id, formData) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldCode: formData.code,
        fldDescription: formData.color,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString()
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.colorMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_COLOR_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_COLOR_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_COLOR_MASTER_FAILURE,
        resetFormData: RESET_USER_FORM_COLOR_MASTER,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchColorMaster()
    };
    return axiosCall(config);
};

// // DELETE PROPERTY MASTER
export let deleteColorMaster = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.colorMasterDelete}/${id}`,
        responseTypeRequest: DELETE_COLOR_MASTER_REQUEST,
        responseTypeSuccess: DELETE_COLOR_MASTER_SUCCESS,
        responseTypeFailure: DELETE_COLOR_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchColorMaster()
    };
    return axiosCall(config);
};
